(function(){
  if(window.__amInit)return;window.__amInit=true;
  function run(){
    var dias=["DOMINGO","LUNES","MARTES","MIÉRCOLES","JUEVES","VIERNES","SÁBADO"],d;
    try{d=new Intl.DateTimeFormat("es-MX",{weekday:"long"}).format(new Date()).toUpperCase()}catch(e){d=dias[new Date().getDay()]}
    document.querySelectorAll('.am .js-day').forEach(function(e){e.textContent=d});
    var t=15*60;function p(n){return n<10?'0'+n:''+n}
    function tick(){var h=Math.floor(t/3600),m=Math.floor(t%3600/60),s=t%60;
      document.querySelectorAll('.am .js-bar').forEach(function(e){e.textContent=p(m)+':'+p(s)});
      document.querySelectorAll('.am .js-h').forEach(function(e){e.firstChild.nodeValue=p(h)});
      document.querySelectorAll('.am .js-m').forEach(function(e){e.firstChild.nodeValue=p(m)});
      document.querySelectorAll('.am .js-s').forEach(function(e){e.firstChild.nodeValue=p(s)});
      if(t>0)t--;}
    tick();setInterval(tick,1000);
  }
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
